import environment from '#/environment/environment';
import {ApiAnnoucementResultBody} from 'shareland-common';

const fetchAnnouncements = async (): Promise<ApiAnnoucementResultBody | undefined> => {
  const announcements = await fetch(`${environment.apiUrl}/announcements`);
  const response = await announcements.json();
  return response?.data;
};

export default fetchAnnouncements;
